import { DataDefinition } from 'json-react-layouts-data-loader'
import { ComponentServices } from '../../routing'
import {
    getLatestIssuesFromMultiplePublications,
    getLatestIssuesFromPublication,
    Issue,
} from './helpers'

export type ePaperLatestEditionDataTypes = {
    numberOfIssues: number
    publication: string
}

export type ePaperLatestEditionDataLoaded = {
    latestIssues: Issue[]
}

export type ePaperLatestEditionDataDefination = DataDefinition<
    ePaperLatestEditionDataTypes,
    ePaperLatestEditionDataLoaded,
    ComponentServices
>

export const ePaperLatestEditionDataDefinationLoader: ePaperLatestEditionDataDefination =
    {
        loadData: async (dataDefinitionArgs, services, content) => {
            const data = await getLatestIssuesFromPublication({
                logger: services.log,
                caller: services.config.apiCallerHeader,
                numberOfIssues: dataDefinitionArgs.numberOfIssues,
                publication: dataDefinitionArgs.publication,
            })

            return data
        },
    }

export const allPublications = [
    'albany-advertiser',
    'great-southern-herald',
    'augusta-margaret-river-times',
    'busselton-dunsborough-times',
    'broome-advertiser',
    'the-kimberley-echo',
    'geraldton-guardian',
    'midwest-times',
    'bunbury-herald',
    'harvey-waroona-reporter',
    'manjimup-bridgetown-times',
    'south-western-times',
    'kalgoorlie-miner',
    'narrogin-observer',
    'north-west-telegraph',
    'pilbara-news',
    'sound-telegraph',
    'countryman',
    'default',
    'perthnow',
] as const

type PublicationTuple = typeof allPublications
export type EpaperPublicationType = PublicationTuple[number]

export type ePaperReadersAlsoLoveDataTypes = {
    publicationsToFetch: EpaperPublicationType[]
}

export type ePaperReadersAlsoLoveDataLoaded = {
    issues: Issue[]
}

export type ePaperReadersAlsoLoveDataDefination = DataDefinition<
    ePaperReadersAlsoLoveDataTypes,
    ePaperReadersAlsoLoveDataLoaded,
    ComponentServices
>

export const ePaperReadersAlsoLoveDataDefinationLoader: ePaperReadersAlsoLoveDataDefination =
    {
        loadData: async (dataDefinationArgs, services, content) => {
            const data = await getLatestIssuesFromMultiplePublications({
                logger: services.log,
                caller: services.config.apiCallerHeader,
                publications: dataDefinationArgs.publicationsToFetch,
            })

            return {
                issues: data,
            }
        },
    }
